export default {"src":"/_next/static/media/trade-in-logo.050ae5a6.svg","height":29,"width":29};